// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'key';

export const Component = () => (
  <path d='M22.881 7.282c0-1.963-.67-3.687-2.06-5.076C19.434.816 17.806.05 15.842.003c-1.963-.048-3.687.575-5.172 1.868-1.485 1.292-2.251 2.92-2.395 4.885-.144 1.963.383 3.736 1.628 5.268L2 19.686l4.645 4.885.767-.766-4.167-4.119 2.921-2.73 3.928 3.928.719-.719-3.928-3.927 3.688-3.544c1.484 1.293 3.208 1.916 5.172 1.868 1.964-.048 3.64-.814 5.03-2.203 1.388-1.39 2.059-3.113 2.106-5.077Zm-2.777 4.598c-1.198 1.245-2.682 1.868-4.454 1.868-1.772 0-3.257-.623-4.502-1.868C9.904 10.635 9.28 9.15 9.28 7.378c0-1.772.623-3.257 1.868-4.454 1.246-1.245 2.73-1.868 4.502-1.868 1.772 0 3.257.623 4.454 1.868 1.245 1.198 1.868 2.682 1.868 4.454 0 1.772-.623 3.257-1.868 4.502Z' />
);

export const viewBox = '0 0 25 25';
